module.exports = __webpack_public_path__ + "img/7ab25c4.png";